import { HttpClient, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class RecotizarService {
	static requoteRequested: EventEmitter<any> = new EventEmitter<any>();

	constructor(private readonly http: HttpClient) {}

	recotizarProposta(proposalId: string, requoteDescription: string): Observable<any> {
	  const url = `${environment.apiUrl}contracts-ka/requote-proposal/${proposalId}?requoteDescription=${encodeURIComponent(requoteDescription)}`;
	  return this.http.patch(url, null);
	}
}